import { __decorate } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import * as THREE from 'three';
import Octree from '@blade-sxp/map/src/controls/OctreeControls';
import Capsule from '@blade-sxp/map/src/controls/CapsuleControls';
import { WebGLRenderer } from '@blade-sxp/map/src/renderer/WebGLRenderer';
import { OrbitControls } from '@blade-sxp/map/src/controls/OrbitControls';
// import { OctreeHelper } from '@blade-sxp/map/src/helpers/OctreeHelper';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { RoomEnvironment } from 'three/examples/jsm/environments/RoomEnvironment.js';
const worldOctree = new Octree();
let OcTree = class OcTree extends Vue {
    worldOctree;
    player;
    car;
    fly;
    playerCollider;
    renderer = new WebGLRenderer({ antialias: true, alpha: true, depth: true });
    controls;
    scene;
    camera = new THREE.PerspectiveCamera(40, window.innerWidth / window.innerHeight, 10, 100000);
    raycaster = new THREE.Raycaster();
    pointer = new THREE.Vector2();
    group = new THREE.Group();
    mounted() {
        // this.worldOctree = new Octree();
        const container = document.getElementById('octree');
        this.renderer.setPixelRatio(window.devicePixelRatio);
        this.renderer.setSize(window.innerWidth, window.innerHeight);
        this.renderer.outputEncoding = THREE.sRGBEncoding;
        container?.appendChild(this.renderer.domElement);
        this.scene = new THREE.Scene();
        // this.scene.background = new THREE.Color(0xbfe3dd);
        const pmremGenerator = new THREE.PMREMGenerator(this.renderer);
        this.scene.environment = pmremGenerator.fromScene(new RoomEnvironment(), 0.04).texture;
        this.scene.add(this.group);
        this.controls = new OrbitControls(this.camera, this.renderer.domElement);
        this.controls.object.position.set(0, 999, 0);
        this.controls.target.set(0, 0, 0);
        this.controls.update();
        // this.scene.add(this.camera);
        // let cameraPerspectiveHelper = new THREE.CameraHelper(this.camera);
        // this.scene.add(cameraPerspectiveHelper);
        window.onresize = () => {
            this.camera.aspect = window.innerWidth / window.innerHeight;
            this.camera.updateProjectionMatrix();
            this.renderer.setSize(window.innerWidth, window.innerHeight);
        };
        const loader = new GLTFLoader();
        // loader.setPath('https://threejs.org/examples/models/gltf/');
        loader.load('/personGltf/Man01.gltf', (gltf) => {
            this.player = gltf.scene;
            // this.player.scale.set(0.01, 0.01, 0.01);
            this.player.position.y = 20;
            this.scene.add(this.player);
        });
        loader.load('/aircraft01/WuRenJi.gltf', (fly) => {
            this.fly = fly.scene;
            this.fly.position.y = 30;
            this.scene.add(this.fly);
        });
        loader.load('/test-model/shelbygtr_free/scene.gltf', (gltf) => {
            this.car = gltf.scene;
            this.car.scale.set(100, 100, 100);
            this.car.updateWorldMatrix(true, true);
            let list = [];
            this.car.traverse((obj) => {
                if (obj.isMesh === true) {
                    let geometry;
                    let isTemp = false;
                    if (obj.geometry.index !== null) {
                        isTemp = true;
                        geometry = obj.geometry.toNonIndexed(); // 返回已索引的 BufferGeometry 的非索引版本
                    }
                    else {
                        geometry = obj.geometry;
                    }
                    const positionAttribute = geometry.getAttribute('position');
                    for (let i = 0; i < positionAttribute.count; i += 3) {
                        const v1 = new THREE.Vector3().fromBufferAttribute(positionAttribute, i);
                        const v2 = new THREE.Vector3().fromBufferAttribute(positionAttribute, i + 1);
                        const v3 = new THREE.Vector3().fromBufferAttribute(positionAttribute, i + 2);
                        v1.applyMatrix4(obj.matrixWorld);
                        v2.applyMatrix4(obj.matrixWorld);
                        v3.applyMatrix4(obj.matrixWorld);
                        list.push(new THREE.Triangle(v1, v2, v3));
                    }
                    if (isTemp) {
                        geometry.dispose();
                    }
                }
            });
            console.log(list.length);
            console.log(this.car);
            this.car.position.y = 10;
            this.scene.add(this.car);
        });
        loader.load('/gltf/JYC/ST_0620.gltf', (obj) => {
            //   obj.scene.children[16].scale.set(50, 50, 50);
            // obj.scene.scale.set(50, 50, 50);
            //   const item = obj.scene;
            //   test.children.splice(20);
            // test.children[0].scale.set(100, 100, 100);
            // test.children[1].scale.set(100, 100, 100);
            //   test.scale.set(100, 100, 100);
            this.group.add(obj.scene);
            fetch('/gltf/JYC/octree.json')
                .then((response) => response.json())
                .then((json) => {
                worldOctree?.fromObject(json, obj.scene);
                console.log('1111');
                // this.worldOctree?.fromObjectAsync(json).then((res) => {
                //   console.timeEnd('1111');
                //   console.log('1', res);
                // });
                // this.worldOctree = worldOctree;
            })
                .catch((err) => console.log('Request Failed', err));
            // this.group.scale.set(100, 100, 100);
            //   console.log('obj.scene', this.group);
            // this.worldOctree?.fromGraphNode(obj.scene);
            // this.worldOctree = worldOctree;
            //   console.log('octree', worldOctree);
            // const helper = new OctreeHelper(worldOctree, 0x049ef4);
            // helper.visible = true;
            // this.scene.add(helper);
            const axesHelper = new THREE.AxesHelper(5000);
            // axesHelper.position.z = -1;
            this.scene.add(axesHelper);
            this.animate();
        });
    }
    animate() {
        window.requestAnimationFrame(this.animate);
        this.controls?.update();
        this.renderer?.render(this.scene, this.camera);
    }
    handleClick(event) {
        if (worldOctree) {
            const rect = this.renderer.domElement.getBoundingClientRect();
            // Standard x and y in standard coordinate, range from [-1, 1]
            this.pointer.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
            this.pointer.y = -((event.clientY - rect.top) / rect.height) * 2 + 1;
            // pointer.set( ( event.clientX / window.innerWidth ) * 2 - 1, - ( event.clientY / window.innerHeight ) * 2 + 1 );
            this.raycaster.setFromCamera(this.pointer, this.camera);
            console.time('射线耗时');
            const intersects = this.raycaster.intersectObject(this.group, true);
            console.timeEnd('射线耗时');
            console.time('八叉树耗时');
            const res = worldOctree.rayIntersect(this.raycaster.ray);
            console.timeEnd('八叉树耗时');
            console.log(intersects[0], res);
            // const res = this.worldOctree.rayIntersect(this.raycaster.ray);
            if (this.car && res) {
                const position = res?.position.clone();
                position.y += 1.5;
                const _position = position.clone();
                // _position.x += 2;
                console.log(worldOctree.lineIntersect(position, _position));
                this.car.position.copy(res?.position);
                const mesh = this.car.children[0].children[1];
                if (!mesh.geometry.boundingBox) {
                    mesh.geometry.computeBoundingBox();
                }
                const box = new THREE.Box3();
                box.copy(mesh.geometry.boundingBox).applyMatrix4(mesh.matrixWorld);
                this.playerCollider = new Capsule(new THREE.Vector3((box.max.x + box.min.x) / 2, box.min.y, (box.max.z + box.min.z) / 2), new THREE.Vector3((box.max.x + box.min.x) / 2, box.max.y, (box.max.z + box.min.z) / 2), 0.35);
                const result = worldOctree.capsuleIntersect(this.playerCollider);
                console.log('result', result);
            }
        }
    }
};
OcTree = __decorate([
    Component({
        name: 'octree',
    })
], OcTree);
export default OcTree;
